// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import link03Icon from "@/assets/icons/link-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Link03IconProps = Omit<IconProps, "name">;

export function Link03Icon(props: Link03IconProps): React.ReactNode {
  return <Icon name={link03Icon} {...props} />;
}
